import React, { useState, useCallback, useRef, Fragment } from "react";
import PropTypes from "prop-types";
import { FormHelperText, TextField, Button, Checkbox, Typography, FormControlLabel } from "@mui/material";
import VisibilityPasswordTextField from "../../../shared/components/VisibilityPasswordTextField";
import withStyles from '@mui/styles/withStyles';
import HighlightedInformation from "../../../shared/components/HighlightedInformation";
import FormDialog from "../../../shared/components/FormDialog";
import ButtonCircularProgress from "../../../shared/components/ButtonCircularProgress";
import { Auth, Amplify } from 'aws-amplify';
import aws_exports from '../../../aws-exports';
Amplify.configure(aws_exports);
const styles = (theme) => ({
  dialogContent: {
    paddingTop: theme.spacing(2),
  },
  dialogActions: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
});

function ChangePassword(props) {
  const { onClose, classes, setLoginStatus, openVerificationCodeDialog } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const pwResetEmail= useRef();

  const sendPasswordCode = useCallback(() => {
    // Send confirmation code to user's email

    setIsLoading(true);

    Auth.forgotPassword(pwResetEmail.current.value)
      .then(data => console.log("data",data))
      .catch(err => console.log(err));
    // setLoginStatus("verificationEmailSend");
    setIsLoading(false);
    openVerificationCodeDialog();


  }, [setIsLoading, setLoginStatus, onClose, pwResetEmail]);

  return (
    <FormDialog
      loading={isLoading}
      onClose={onClose}
      open
      onFormSubmit={(e) => {
        e.preventDefault();
        sendPasswordCode();
      }}
      hideBackdrop
      hasCloseIcon
      headline="Forgot Password"
      maxWidth="s"
      content={
        <Fragment >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Email Address"
            inputRef={pwResetEmail}
            autoFocus
            autoComplete="off"
            type="email"
          />
        </Fragment>
      }
      actions={
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          color="secondary"
          disabled={isLoading}
        >
          Submit
          {isLoading && <ButtonCircularProgress />}
        </Button>
      }
    />
  );
}

ChangePassword.propTypes = {
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  setLoginStatus: PropTypes.func.isRequired,
  openVerificationCodeDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(ChangePassword);
